module.exports = __webpack_public_path__ + "img/img_title.0e9593cf.gif";